
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AngularTokenService } from '@raysuelzer/angular-token';
import { of as observableOf } from 'rxjs';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';

import { clearPasswordResetMessage } from 'app/_state/auth/auth-actions';
import { selectPasswordResetMessage } from 'app/_state/auth/auth-selectors';
import { AuthState } from 'app/_state/auth/auth-state';
import { authGuard } from 'core/guards/auth.guard';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-login-box',
  templateUrl: './login-box.component.html'
})

export class LoginBoxComponent extends WithDisposableSubject() implements OnInit {
  email: string;
  password: string;

  // set to true after user interacts with page
  // because Chrome and other browsers do not expose
  // the password to a page until the user has clicked
  // an element, we do not disable the login button
  // until the user has interacted with the page
  userInteracted = false;

  pwShown = false;
  errorMessages: Array<string>;
  successMessage: string = null;
  // disables submit button
  isSubmitting = false;

  constructor(
    private authService: AngularTokenService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private store: Store<AuthState>) {
    super();
  }

  ngOnInit() {
    this.store.select(
      selectPasswordResetMessage
    ).pipe(
      takeUntil(this.disposer)
    ).subscribe((message) => {
      this.successMessage = message;
    });
  }

  /**
   * Called when a user clicks login.
   *  - Calls the backend to validate the password.
   *  - Checks if the appState already contains a current campaign
   *    -- If not, calls graphQL to get a list of campaigns and sets the current
   *       campaign to the first result in the list.
   */
  login() {
    this.isSubmitting = true;
    this.errorMessages = [];

    // clear success message
    this.store.dispatch(
      clearPasswordResetMessage()
    );
    this.authService.signIn({ login: this.email, password: this.password }).pipe(
      finalize(() => this.isSubmitting = false),
      switchMap((res) => observableOf(res)))
      .subscribe(
        // Success
        _ => {
          //this.authGuard.resetValidationObservable();
          this.router.navigateByUrl('');
        },
        // Error
        res => {
          this.password = '';
          if (res.status === 401) {
            this.errorMessages = res.error.errors;
          }
          this.cd.markForCheck();
        }
      );
  }

}
